import { BaseAccomodationConverter } from '@converters/base-accomodation.converter';
import { CardLinkConverter } from '@converters/card-link.converter';
import { CardSuggestionsTranslationConverter } from '@converters/card-suggestions-translation.converter';
import { CardTextConverter } from '@converters/card-text.converter';
import { DataloginConverter } from '@converters/data-login.converter';
import { LocationConverter } from '@converters/location.converter';
import { PersonConverter } from '@converters/person.converter';
import { UserConverter } from '@converters/user.converter';
import { ContactConverter } from '@converters/contact.converter';
export abstract class BaseService {
    protected dataLoginConverter = new DataloginConverter();
    protected userConverter = new UserConverter();
    protected personConverter = new PersonConverter();
    protected baseAccomodationConverter = new BaseAccomodationConverter();
    protected cardTextConverter = new CardTextConverter();
    protected cardLinkConverter = new CardLinkConverter();
    protected cardSuggestionConverter = new CardSuggestionsTranslationConverter();
    protected cardLocationConverter = new LocationConverter();
    protected contactConverter = new ContactConverter();
} 